import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import ChimneyRepairService from "./Components/Services/ChimneyRepairService";
import HobRepairService from "./Components/Services/HobRepairService";
import CooktopRepairService from "./Components/Services/CookTopRepairService";
import GasStoveRepairService from "./Components/Services/GasStoveRepairService";
import OvenMicrowaveRepairService from "./Components/Services/OvenMicroWareRepairService";
import ContactUs from "./Components/ContactUs";
import CookingRangeService from "./Components/Services/CookingRangeService";
import GasServiceRepair from "./Components/Services/GasServiceRepair";
import ResidentialPestControl from "./Components/Services/ResidentialPestControl";
import SupportWidget from "./Components/SupportWidget";
import AllServices from "./Components/AllServices";
import Gallery from './Components/Gallery';
import LeadPopup from './Components/LeadPopup';

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/cockroach-control" element={<ChimneyRepairService />} />
        <Route path="/termite-control" element={<HobRepairService />} />
        <Route path="/bed-bug-control" element={<CooktopRepairService />} />
        <Route path="/rodent-control" element={<GasStoveRepairService />} />
        <Route path="/mosquito-control" element={<GasServiceRepair />} />
        <Route path="/general-pest-control" element={<OvenMicrowaveRepairService />} />
        <Route path="/commercial-pest-control" element={<CookingRangeService />} />
        <Route path="/residential-pest-control" element={<ResidentialPestControl />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/all-services" element={<AllServices />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <SupportWidget />
      <LeadPopup />
      <Footer />
    </>
  );
};

export default App;